import { createContext, useContext } from 'react';

export const DialogContext = createContext({
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	close: (): void => {},
});

export const useDialogContext = () => useContext(DialogContext);
